import WithdrawalHistoryItem from './WithdrawalHistoryItem';
export default WithdrawalHistoryItem;